import React, {useEffect} from 'react';
import CampaignSearch from "./search";
import {useLocation} from "react-router";
//import {Link} from 'react-router-dom';
import { CostsReport } from './costreport';
import { CostsReportNew } from './costReportNew';
import { CreativeReport } from './creativereport';
import { CreativeReportNew } from './creativeReportNew';
import { DigitalReportNew } from './digitalReportNew';
import { useState } from 'react';
import {
  Campaign,
  CampaignsSearchQueryDocument,
  useDeleteCampaignMutationMutation
} from '../../generated/graphql';
import {Button} from "@mui/material";
import {Download} from "@mui/icons-material";
import {useUserContext} from "../../contexts/user-context";
import {SideList} from "../../components/SideList";
import {useRecordModuleHistory} from "../../contexts/module-history-context";
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";
import { SundriesReport } from './SundriesReport';
import { SundriesReportNew } from './sundriesReportNew';
import { useExchangeRatesContext } from '../../contexts/exchange-rates-context';
import { AreaBookingReport } from './AreaBookingReport';
import { AreaBookingReportNew } from './areaBookingReportNew';
import { DigitalBookingReport } from './DigitalBookingReport';
import { isoTimestampToUk } from '../../utils';

export const Campaigns = () => {
  const location = useLocation();
  const isCreativeStudio = location.pathname.startsWith('/cs-campaigns');
  // /campaigns keeps its default standard-only list filter as a hidden fixed variable; on
  // /cs-campaigns the creative-studio restriction is the pre-selected search field instead, so
  // no fixed variable is passed (design D3).
  const typeFilter = isCreativeStudio ? undefined : ['standard'];
  const baseUrl = isCreativeStudio ? '/cs-campaigns/' : '/campaigns/';
  const [doCostReport,setDoCostReport] = useState(false);
  const [doCostReportNew,setDoCostReportNew] = useState(false);
  const [doCreativeReport,setDoCreativeReport] = useState(false);
  const [doCreativeReportNew,setDoCreativeReportNew] = useState(false);
  const [doDigitalReport, setDoDigitalReport] = useState(false);
  const [doDigitalReportNew, setDoDigitalReportNew] = useState(false);
  const [doAreaBookingReport,setAreaBookingReport] = useState(false);
  const [doAreaBookingReportNew,setAreaBookingReportNew] = useState(false);
  const [doSundriesReport,setDoSundriesReport] = useState(false);
  const [doSundriesReportNew,setDoSundriesReportNew] = useState(false);
  const currencyContext = useExchangeRatesContext();
  const userContext = useUserContext();
  const arrayIndex = 0;
  const columns:FieldTableColumnProps<Campaign>[] = [
    {
      accessor:'job_reference',
      header: 'Job Ref',
      dataType:'link',
      width: 'minmax(4em, max-content)',
      options:{
        getLink:({field}) => {
          return {
            pathname: baseUrl + field?.value,
            search: (location.search ? location.search : '')
          };
        }
/*      renderViewer:useCallback(({field})=> {
        return (<Link component={RouterLink} href={
          '/campaigns/' + field.value+(location.search ? '?'+location.search : '')
        }>{field.value}</Link>);
        return (<Link underline="always" component={RouterLink} to={}>{field.value}</Link>);
      },[location.search])*/
    }
    },{
      accessor:'status',
      header:'Status',
      width: 'minmax(4em, max-content)',
      dataType:'default'
    },{
      accessor:'name',
      header:'Job Name',
      className:'column-width-wide-plus',
      dataType:'default'
    },{
      accessor:'clientCompany.sales_company',
      header:'Client',
      className:'column-width-wide-plus',
      dataType:'default'
    },{
      accessor:'salesTeam.name',
      header:'Sales Team',
      dataType:'default'
    },{
      accessor:'sub_teams_scotland',
      header:'Sub Sales Team',
      dataType:'default'
    },{
      accessor:'ourContact.name',
      header:'Account Manager',
      dataType:'default'
    },{
      accessor:'total_price',
      header:'Total exc VAT',
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      readOnly:true
    },{
      accessor:'photo_paid_total',
      header:'Pro Photo Total',
      exportOnly: true,
      dataType:'currency',
      readOnly:true,
    },{
      accessor:'start_date',
      header:'Start Date',
      exportOnly: true,
      dataType:'date',
      readOnly:true,
    },{
      accessor:'completion_date',
      header:'Completion Date',
      dataType:'date',
      readOnly:true,
    },{
      accessor:'purchase_order',
      header:'Purchase Order',
      dataType:'default',
      exportOnly: true
    },{
      accessor:'notes',
      header:'Notes',
      dataType:'default',
      exportOnly: true
    },{
      accessor:'invoice',
      header:'Invoice Number',
      dataType:'default',
      exportOnly: true
    },{
      accessor:'totals.experiential',
      header:'Experiential Total',
      exportOnly:true,
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      readOnly:true
    },{
      accessor:'totals.ambient',
      header:'Ambient Total',
      exportOnly:true,
      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.creativestudio',
      header:'Creative Studio Total',
      exportOnly:true,

      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.area_booking',
      header:'Area Booking Total',
      exportOnly:true,
      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.panel_booking',
      header:'Panel Booking Total',
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      exportOnly:true
    },{
      accessor:'totals.digital_booking',
      header:'Digital Booking Total',
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      },
      exportOnly:true
    },{
      accessor:'discount_final',
      header:'Goodwill Discount',
      exportOnly:true,
      dataType:'currency'
    },{
      accessor:'discountableTotal',
      header:'Discountable Total',
      exportOnly:true,
      dataType:'currency'
    },{
      accessor:'discount_percentage',
      header:'Discount Percentage %',
      exportOnly:true,
      dataType:'default'
    },{
      accessor:'totals.media_production',
      header:'Media Production Total',
      exportOnly:true,
      options: {
        currency: {
          accessor:'currency'
        }
      },
      dataType:'currency'
    },{
      accessor:'totals.sundry',
      header:'Other Revenue Total',
      exportOnly:true,
      dataType:'currency',
      options: {
        currency: {
          accessor:'currency'
        }
      }
    },{
      accessor:'posters_received',
      header:'Posters Received',
      dataType:'boolean',
      exportOnly: true
    },{
      accessor:'clientSubType.name',
      header: 'Campaign Sector',
      dataType:'default'
    },{
      accessor:'clientCompany.clientType.name',
      header: 'Client Type',
      dataType:'default'
    },{
      accessor:'regionalAmAllocation.name',
      header: 'Regional Allocation',
      dataType:'default',
    },{
      accessor:'currency.label',
      header:'Quote Currency',
      dataType:'default',
      exportOnly: true
    },
    {
      accessor: 'confirmationEntry.occurredAt',
      header: 'Confirmation Date',
      dataType: 'default',
      exportOnly: true,
      options: {
        getValue: ({ row }) => {
          if (row?.confirmationEntry?.occurredAt) {
            return isoTimestampToUk(row.confirmationEntry.occurredAt);
          }
        },
      }
    }
  ];
  
  const searchForm = (args) => {
    return <CampaignSearch {...args} isCreativeStudio={isCreativeStudio} />;
  };
  const costReport = (args) => {
    setDoCostReport(true);
  }
  const costReportNew = (args) => {
    setDoCostReportNew(true);
  }
  const creativeReport = (args) => {
    setDoCreativeReport(true);
  }
  const creativeReportNew = (args) => {
    setDoCreativeReportNew(true);
  }
  const digitalReport = (args) => {
    setDoDigitalReport(true);
  }
  const digitalReportNew = (args) => {
    setDoDigitalReportNew(true);
  }
  const areaBookingReport = (args) => {
    setAreaBookingReport(true);
  }
  const areaBookingReportNew = (args) => {
    setAreaBookingReportNew(true);
  }
  const sundriesReport = (args) => {
    setDoSundriesReport(true);
  }
  const sundriesReportNew = (args) => {
    setDoSundriesReportNew(true);
  }
  const recordModuleHistory = useRecordModuleHistory();
  useEffect(() => {
    recordModuleHistory(isCreativeStudio ? 'cs-campaigns' : 'campaigns');
  }, [recordModuleHistory, location, isCreativeStudio]);
  const deleteMutation = useDeleteCampaignMutationMutation();
  return <SideList
      searchForm={searchForm}
      label="Campaign"
      skipScroll={true}
      className="campaigns"
      permission="campaigns"
      deleteMutation={deleteMutation}
      simpleDelete={true}
      getResults={(e)=>e.campaigns.data}
       query={CampaignsSearchQueryDocument}
       columns={columns}
       baseUrl={baseUrl}
       fixedVariables={typeFilter ? {type_in: typeFilter} : undefined}
       hasDelete={false}
      noEditorScroll={true}
      extraContent={(props)=>{
        if(doCostReport) return (<CostsReport done={()=>{setDoCostReport(false)}}/>);
        if(doCostReportNew) return (<CostsReportNew campaigns={props} done={()=>{setDoCostReportNew(false)}}/>);
        if(doCreativeReport) return (<CreativeReport done={()=>{setDoCreativeReport(false)}}/>);
        if(doCreativeReportNew) return (<CreativeReportNew campaigns={props} done={()=>{setDoCreativeReportNew(false)}}/>);
        if(doDigitalReport) return (<DigitalBookingReport done={()=>{setDoDigitalReport(false)}}/>);
        if(doDigitalReportNew) return (<DigitalReportNew campaigns={props} done={()=>{setDoDigitalReportNew(false)}}/>);
        if(doSundriesReport) return (<SundriesReport done={()=>{setDoSundriesReport(false)}}/>);
        if(doSundriesReportNew) return (<SundriesReportNew campaigns={props} done={()=>{setDoSundriesReportNew(false)}}/>);
        if(doAreaBookingReport) return (<AreaBookingReport done={()=>{setAreaBookingReport(false)}}/>);
        if(doAreaBookingReportNew) return (<AreaBookingReportNew campaigns={props} done={()=>{setAreaBookingReportNew(false)}}/>);
        return <></>;
      }}
      footer={userContext.hasPermission('reports.run')?<>
      <Button size="large" key="exportBtnAdv" onClick={costReport} startIcon={<Download/>}>Cost Report</Button>
      <Button size="large" key="exportBtnAdvNew" onClick={costReportNew} startIcon={<Download/>}>Cost Report (new)</Button>
      <Button size="large" key="exportBtnAdv" onClick={creativeReport} startIcon={<Download/>}>Creative Studio Report</Button>
      <Button size="large" key="exportBtnCreativeNew" onClick={creativeReportNew} startIcon={<Download/>}>Creative Studio Report (new)</Button>
      <Button size="large" key="exportBtnAdv" onClick={digitalReport} startIcon={<Download/>}>Digital Booking Report</Button>
      <Button size="large" key="exportBtnDigitalNew" onClick={digitalReportNew} startIcon={<Download/>}>Digital Booking Report (new)</Button>
      <Button size="large" key="exportBtnAdv" onClick={areaBookingReport} startIcon={<Download/>}>Area Booking Report</Button>
      <Button size="large" key="exportBtnAreaNew" onClick={areaBookingReportNew} startIcon={<Download/>}>Area Report (new)</Button>
      <Button size="large" key="exportBtnAdv" onClick={sundriesReport} startIcon={<Download/>}>Other Report</Button>
      <Button size="large" key="exportBtnSundriesNew" onClick={sundriesReportNew} startIcon={<Download/>}>Other Report (new)</Button>
      </>:[]}
    />;

//  return (<SideEditor
//  ><Outlet/></SideEditor>);
}

